import { z } from "zod";

export const UserSchema = z.object({
  uid: z.number(),
  ulogin: z.string().nullable().optional(),
  upass: z.string().nullable().optional(),
  ufirstn: z.string().nullable().optional(),
  ulastn: z.string().nullable().optional(),
  uemail: z.string().nullable().optional(),
  uphone: z.string().nullable().optional(),
  uphonemobile: z.string().nullable().optional(),
  uadddts: z.string().nullable().optional(),
  uaddid: z.number().nullable().optional(),
  ueditdts: z.string().nullable().optional(),
  ueditid: z.number().nullable().optional(),
  ulastlogin: z.string().nullable().optional(),
  ulastdts: z.string().nullable().optional(),
  ulastpassdts: z.string().nullable().optional(),
  uestimate: z.string().nullable().optional(),
  uclients: z.string().nullable().optional(),
  ujobs: z.string().nullable().optional(),
  uinstaller: z.string().nullable().optional(),
  utemplates: z.string().nullable().optional(),
  usuper: z.string().nullable().optional(),
  ustatus: z.string().nullable().optional(),
  uexpire: z.number().default(0),
  utitl: z.string().nullable().optional(),
  usys: z.string().nullable().optional(),
  ulock: z.string().nullable().optional(),
  umenuoverride: z.string().nullable().optional(),
  ucid: z.number().default(1),
  uaddpart: z.string().nullable().optional(),
  uaddpartrate: z.string().nullable().optional(),
  udefLot: z.string().nullable().optional(),
  ucntE: z.string().nullable().optional(),
  ucolor: z.string().nullable().optional(),
  ukey: z.string().nullable().optional(),
  uperms: z.string().nullable().optional(),
  ustart: z.string().nullable().optional(),
  ustartmobile: z.string().nullable().optional(),
  ufieldRe: z.string().nullable().optional(),
  uroles: z.string().nullable().optional(),
  urolesBKUP: z.string().nullable().optional(),
  uassign: z.string().nullable().optional(),
  uwidgets: z.string().nullable().optional(),
  urate: z.number().nullable().optional(),
  ulang: z.string().nullable().optional(),
  uintegrationcc: z.string().nullable().optional(),
  ucompanies: z.string().nullable().optional(),
  uservices: z.string().nullable().optional(),
  usalesgoal: z.number().nullable().optional(),
  usalesgoaly: z.string().nullable().optional(),
  ustagingaccess: z.boolean().nullable().optional(),
  umasteraccess: z.boolean().nullable().optional(),
});

export type User = z.infer<typeof UserSchema>; 